/**
 * @file NotificationHistoryReport.js
 * @description CSV report export configuration and trigger for messages history report data.
 */

import { format } from 'date-fns';
import { getDateFromZulu } from '../../helpers/getDateFromZulu';
import { getMessagesHistories } from '../../../services/clientService';
import {
    createCsvReportDefinition,
    exportCsvReport,
} from '../../../utils/reporting/csvReportExporter';

const messagesHistoryReportHeaders = [
    'Name',
    'Display Name',
    'Sent',
    'Category',
    'Population Groups',
];

function mapMessagesHistoryRow(demographic) {
    return {
        name: demographic.name,
        displayName: demographic.displayName,
        sentAt: getDateFromZulu(demographic.sentAt),
        notificationCategory: demographic.notificationCategory,
        populationGroups: demographic.populationGroups.join(', '),
    };
}

async function getMessagesHistoryData(
    startDate,
    endDate,
    searchTerm,
    sort,
    order,
) {
    const fetchedImports = await getMessagesHistories(
        format(startDate, 'yyyy-MM-dd'),
        format(endDate, 'yyyy-MM-dd'),
        searchTerm,
        sort,
        order,
    );

    const formattedImports = fetchedImports.viewModels;
    return formattedImports;
}

function getMessagesHistoryReportDefinition(
    startDate,
    endDate,
    searchTerm,
    sort,
    order,
) {
    return createCsvReportDefinition({
        filenamePrefix: 'messagesHistoryReport',
        getData: () =>
            getMessagesHistoryData(startDate, endDate, searchTerm, sort, order),
        mapRow: mapMessagesHistoryRow,
    });
}

export async function downloadReport(
    startDate,
    endDate,
    searchTerm,
    sort,
    order,
) {
    await exportCsvReport(
        getMessagesHistoryReportDefinition(
            startDate,
            endDate,
            searchTerm,
            sort,
            order,
        ),
    );
}
